import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class CheckoutBtn extends Component {
	render() {
		if(this.props.cart.items.length){
			return (
				<li>
					<div className="hbs-checkout-btn">
						<Link to="/checkout">Checkout</Link>
					</div>
				</li>
			)
		}else{
			return (
				<div></div>
			)
		}
	}
}

export default CheckoutBtn



// WEBPACK FOOTER //
// ./src/components/header/CheckoutBtn.js